import React from 'react';
import { Card } from './ui/card';

export const WhyClientsSection = () => {
  const reasons = [
    "I don't feel good about my body",
    "I am struggling with my relationships",
    "I get really angry and it hurts me",
    "I lost someone close to me",
    "I feel overwhelmed with life decisions",
    "I am struggling with anxiety",
    "I feel lost or stuck in my life",
    "I want a therapist who understands queer experiences",
    "I don't feel understood in my family"
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-pink-50 via-blue-50 to-purple-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-800 mb-12">
          Why talk to me
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <Card 
              key={index}
              className="p-6 bg-white/70 backdrop-blur-sm border-none shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <p className="text-lg text-gray-700 text-center leading-relaxed">
                "{reason}"
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};